module.exports = __webpack_public_path__ + "img/bizui.92bf7127.gif";